import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentSipDonorsComponent } from './payment-sip-donors.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [PaymentSipDonorsComponent],
  exports: [PaymentSipDonorsComponent],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class PaymentSipDonorsModule { }
